/**
 * 表示用の標準チェックイン/チェックアウト時刻。
 * チェックインは core-system 側の STANDARD_CHECK_IN_START_HOUR (15時) と同じ値。
 * チェックアウトに対応する API 値は存在しないため、両方とも表示専用の固定値として扱う。
 */
export const STANDARD_CHECK_IN_TIME = "15:00";
export const STANDARD_CHECK_OUT_TIME = "11:00";
